import { toast } from "./toast";

const API = `${(process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "")}/api`;
let accessToken = null;
const hues = {};
export const hueOf = (code) => hues[code];

export const setToken = (t) => { accessToken = t; };
export const getToken = () => accessToken;

async function call(path, method, body, auth) {
  const headers = { "Content-Type": "application/json" };
  if (auth && accessToken) headers.Authorization = `Bearer ${accessToken}`;
  if (method !== "GET" && !path.startsWith("/auth/")) headers["Idempotency-Key"] = crypto.randomUUID();
  return fetch(`${API}${path}`, { method, headers, credentials: "include", body: body ? JSON.stringify(body) : undefined });
}

// identical GETs that overlap (Shell and Floor both reading the floor after the same event) share one request
const inflight = new Map();
export function api(path, opts = {}) {
  const method = opts.method || "GET";
  if (method !== "GET") { inflight.clear(); return send(path, opts); }
  if (!inflight.has(path)) inflight.set(path, send(path, opts).finally(() => inflight.delete(path)));
  return inflight.get(path);
}

async function send(path, { method = "GET", body, auth = true } = {}) {
  let res;
  try {
    res = await call(path, method, body, auth);
    if (res.status === 401 && auth && !path.startsWith("/auth/")) {
      const t = await refreshOnce();
      if (t) {
        setToken(t);
        res = await call(path, method, body, auth);
      }
    }
  } catch {
    return { ok: false, status: 0, error: { code: "NETWORK", message: "Could not reach CK Tiffin. Try again." } };
  }
  const data = res.status === 204 ? null : await res.json().catch(() => null);
  if (res.ok && path === "/clients") (data?.items || []).forEach((c) => { if (c.hue != null) hues[c.code] = c.hue; });
  if (!res.ok) return { ok: false, status: res.status, error: data?.error || { code: "ERROR", message: "Something went wrong. Try again." } };
  return { ok: true, status: res.status, data };
}

export const post = (path, body = {}) => api(path, { method: "POST", body });
export const patch = (path, body) => api(path, { method: "PATCH", body });

let refreshing = null;
export function refreshOnce() {
  refreshing = refreshing || call("/auth/refresh", "POST", null, false)
    .then(async (r) => (r.ok ? (await r.json()).accessToken : null)).catch(() => null)
    .finally(() => { setTimeout(() => { refreshing = null; }, 0); });
  return refreshing;
}

let restoring = null;
export function restore() {
  restoring = restoring || doRestore().finally(() => { setTimeout(() => { restoring = null; }, 0); });
  return restoring;
}

async function doRestore() {
  const t = await refreshOnce();
  if (!t) return null;
  setToken(t);
  const me = await api("/me");
  return me.ok ? me.data : null;
}

export function flash(message, undo) {
  toast(message, undo);
}

export async function act(promise) {
  const r = await promise;
  flash(r.ok ? r.data?.message : r.error.message);
  return r;
}
